import React, { useEffect, useState } from "react";
import {
  Control,
  FieldValues,
  UseFormGetValues,
  UseFormSetValue,
} from "react-hook-form";
import {
  LocationContextProps,
  useLocationsContext,
} from "../../../context/LocationsContext";
import {
  Country,
  getSubdivisionsFromCountry,
} from "../../routeComponents/Locations/Country";
import { FormLocation } from "../../routeComponents/Locations/Location";
import { useTranslation } from "react-i18next";
import { Select } from "@velocity-ehs/component-library";

type StateProvinceSelectProps<TData extends FieldValues> = {
  country: Country | undefined;
  setValue: UseFormSetValue<FormLocation>;
  getValues: UseFormGetValues<FormLocation>;
  errors: any;
  control: Control<TData>;
  disabled: boolean;
  readOnly?: boolean;
};

const StateProvinceSelect = <TData extends FieldValues>({
  control,
  errors,
  country,
  setValue,
  getValues,
  disabled,
  readOnly,
}: StateProvinceSelectProps<TData>): React.ReactElement => {
  const { t } = useTranslation();
  const locationsContext: LocationContextProps = useLocationsContext();
  const subdivisions = getSubdivisionsFromCountry(
    country,
    locationsContext.countryList
  );
  const [key, setKey] = useState<number>(0);

  useEffect(() => {
    const sub = getValues("address.subdivision");
    if (sub && country && sub?.countryCode !== country?.countryCode) {
      setValue("address.subdivision", null);
      setKey(key + 1);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [country]);

  return (
    <Select
      key={`subdivision_${key}`}
      control={control}
      name="address.subdivision"
      label={t("locations_State")}
      options={subdivisions}
      display="name"
      errorMessage={errors.address?.subdivision?.message}
      disabled={disabled}
      required
      readOnly={readOnly}
    />
  );
};

export default StateProvinceSelect;
